import LegalDisclaimer from './LegalDisclaimer';
import TextStyling from './TextStyling';
import ResourcesModule from './ResourcesModule';

const Segment = ({ id = '', paragraph = [], bulletlist = [] } = {}) => ({
  id: String(id),
  paragraph: paragraph.map((item) => TextStyling(item)),
  bulletlist: bulletlist.map((bullet) => bullet.map((item) => TextStyling(item))),
});

const Section = ({ title = {}, header = '', description = [], segments = [] } = {}) => ({
  title: TextStyling(title),
  header: TextStyling(header),
  description: description.map((item) => TextStyling(item)),
  segments: segments.map((segment) => Segment(segment)),
});

const SectionsGroup = ({ header = '', sections = [] } = {}) => ({
  header: String(header),
  sections: sections.map((item) => Section(item)),
});

const RentalProtectionProductDetailsContent = ({
  header = '',
  subheader = '',
  description = [],
  sections = [],
  sectionsGroup = {},
  legalDisclaimer = {},
  resourcesModule = {},
  footer = [],
} = {}) => ({
  header: String(header),
  subheader: String(subheader),
  description: description.map((item) => TextStyling(item)),
  sections: sections.map((item) => Section(item)),
  sectionsGroup: SectionsGroup(sectionsGroup),
  legalDisclaimer: LegalDisclaimer(legalDisclaimer),
  resourcesModule: ResourcesModule(resourcesModule),
  footer: footer.map((item) => TextStyling(item)),
});

export default RentalProtectionProductDetailsContent;
